import { useMutation } from 'react-query';

import { setComponent as mutationFn } from 'api/endPoints/setComponent';
import { QueryResponse } from 'api/mutations/setComponentSpecificFields.mutation';

import { UpdateCreateWidget } from 'components/Dashboards/Reporting/reporting.types';

export const useMutationSetComponent = () => {
    return useMutation<QueryResponse, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

type QueryParams = UpdateCreateWidget;
